/* eslint-disable @khanacademy/ts-no-error-suppressions */
import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import Tooltip from "@khanacademy/wonder-blocks-tooltip";
import {staticUrl} from "@repo/urls";

import {getTextForBadgeInexact} from "#badges-package/badge-translations.ts";

import type {DiscussionBadge} from "../types.ts";

type Props = Readonly<{
    badges?: Array<DiscussionBadge>;
    isLocked?: boolean;
    isPinned?: boolean;
}>;

export const Badges = (props: Props): React.ReactElement | null => {
    const statusBadges = (): Array<DiscussionBadge> => {
        const statuses: Array<DiscussionBadge> = [];
        if (props.isLocked) {
            statuses.push({
                name: "locked",
                translatedDescription: t`This discussion is locked`,
                icons: {
                    small: "/images/discussions/discussions-lock.svg",
                },
            });
        }
        if (props.isPinned) {
            statuses.push({
                name: "pinned",
                translatedDescription: t`This post is pinned`,
                icons: {
                    small: "/images/discussions/discussions-pin.svg",
                },
            });
        }
        return statuses;
    };

    const fallbackIcon: Record<string, string> = {
        locked: "/images/discussions/discussions-lock@3x.png",
        pinned: "/images/discussions/discussions-pin@3x.png",
    };

    const badges = [...(props?.badges || []), ...statusBadges()];

    if (badges.length === 0) {
        return null;
    }

    return (
        <View style={styles.badges}>
            {badges.map((badge, index) => {
                const {icons, translatedDescription, name} = badge;
                const iconUrl = icons.small || icons.smallUrl;
                const title =
                    translatedDescription ||
                    getTextForBadgeInexact(
                        {
                            name: badge.name || "",
                            description: badge.description || "",
                            fullDescription: "",
                        },
                        false,
                    ).translatedDescription;
                return (
                    <Tooltip content={title} key={name}>
                        <View>
                            <img
                                className={css(styles.badge)}
                                // @ts-expect-error - TS2769 - No overload matches this call.
                                src={staticUrl(iconUrl)}
                                alt={title}
                                onError={({currentTarget}) => {
                                    currentTarget.onerror = null;
                                    if (fallbackIcon[name || ""]) {
                                        currentTarget.src =
                                            fallbackIcon[name || ""];
                                    }
                                }}
                            />
                        </View>
                    </Tooltip>
                );
            })}
        </View>
    );
};

const styles = StyleSheet.create({
    badges: {
        flexDirection: "row",
    },
    badge: {
        width: 16,
        height: 16,
        marginLeft: 4,
    },
});

export default Badges;
